import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-wizard',
  templateUrl: './skeleton-wizard.component.html',
  styleUrls: ['./skeleton-wizard.component.scss']
})
export class SkeletonWizardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
